import { createContext, useContext, useState, useCallback } from 'react';

const ActionsCountContext = createContext({ count: 0, setCount: () => {}, decrement: () => {} });

export function ActionsCountProvider({ children }) {
  const [count, setCount] = useState(0);
  const decrement = useCallback(() => setCount(prev => Math.max(0, prev - 1)), []);
  return (
    <ActionsCountContext.Provider value={{ count, setCount, decrement }}>
      {children}
    </ActionsCountContext.Provider>
  );
}

export const useActionsCount = () => useContext(ActionsCountContext);
